import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea435cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exercise__start" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","margin":"3rem auto"} }
const _hoisted_3 = {
  key: 1,
  class: "exercise__start__get_ready",
  "data-test": "ex-start-counter"
}
const _hoisted_4 = { "data-test": "ex-start-counter-value" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_warning_note = _resolveComponent("app-warning-note")!
  const _component_app_round_phases = _resolveComponent("app-round-phases")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.counter === _ctx.countdownTime)
        ? (_openBlock(), _createBlock(_component_app_button, {
            key: 0,
            "data-test": "ex-start-start-btn",
            onClick: _ctx.startExercise,
            style: {"padding-left":"3rem","padding-right":"3rem"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ex.start.start")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("ex.start.get_ready")), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.counter > 0 ? _ctx.counter : _ctx.$t("ex.start.go")), 1)
          ]))
    ]),
    (_ctx.counter === _ctx.countdownTime)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.counter === _ctx.countdownTime)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_app_warning_note, { "data-test": "ex-start-warning-note" }),
          _createVNode(_component_app_round_phases, { "data-test": "ex-start-round-phases" }),
          _createVNode(_component_app_button, {
            "data-test": "ex-start-see-instr-btn",
            style: {"margin-top":"2rem"},
            variant: "outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: 'BreathingExerciseInstructions',
          })
        ))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ex.start.see_instructions")), 1)
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}